var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "my-account__usage-graph-wrapper",
      style: { "min-height": _vm.height }
    },
    [
      _c("div", { ref: "usageGraphRef" }),
      _vm._v(" "),
      !_vm.usageData
        ? _c("div", { staticClass: "my-account__usage-loading" })
        : _vm._e(),
      _vm._v(" "),
      _vm.noData
        ? _c("div", { staticClass: "my-account__usage-nodata" }, [
            _vm._v("No data for the selected interval.")
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }